import { Form, Input, Modal, useForm } from "@pankod/refine-antd";
import {
  BaseRecord,
  HttpError,
  useMutation,
  useNotification,
} from "@pankod/refine-core";
import { ReactNode, useState } from "react";
import { changePassword as _changePassword } from "services/user";
import { extractApiErrorMessage } from "utils/utils";

export interface IChangePasswordForm {
  new_password: string;
  confirm_password: string;
  old_password?: string;
}

interface ChangePasswordModalProps {
  trigger: ReactNode;
  isSelfChange?: boolean;
  userId: string;
}

export function ModalChangePassword({
  trigger,
  isSelfChange,
  userId,
}: ChangePasswordModalProps) {
  const { open } = useNotification();
  const { formProps, saveButtonProps } = useForm<
    BaseRecord,
    HttpError,
    IChangePasswordForm
  >();
  const [isOpen, setIsOpen] = useState(false);

  const { mutate: changePassword, isLoading: loading } = useMutation({
    mutationFn: _changePassword,
  });

  const handleClose = () => {
    formProps.form?.resetFields();
    setIsOpen(false);
  };

  const handleError = (error: any) => {
    open?.({
      type: "error",
      description: "Erro!",
      message: extractApiErrorMessage(error),
    });

    formProps.form?.resetFields();
  };

  const handleSuccess = () => {
    open?.({
      type: "success",
      description: "Sucesso!",
      message: "Senha alterada com sucesso!",
    });

    handleClose();
  };

  const handleChange = ({
    confirm_password: _,
    ...values
  }: IChangePasswordForm) => {
    changePassword(
      {
        userId: userId || "",
        ...values,
      },
      {
        onSuccess: handleSuccess,
        onError: handleError,
      }
    );
  };

  return (
    <>
      <span onClick={() => setIsOpen(true)} style={{ cursor: "pointer" }}>
        {trigger}
      </span>

      <Modal
        title="Alterar Senha"
        visible={isOpen}
        onCancel={handleClose}
        okButtonProps={{ ...saveButtonProps, loading }}
        okText="Salvar"
        cancelText="Cancelar"
      >
        <Form {...formProps} layout="vertical" onFinish={handleChange}>
          {isSelfChange && (
            <Form.Item
              label="Senha atual"
              name="old_password"
              rules={[{ required: true, message: "Digite a senha atual" }]}
            >
              <Input.Password placeholder="Digite a senha atual" />
            </Form.Item>
          )}

          <Form.Item
            label="Nova senha"
            name="new_password"
            rules={[{ required: true, message: "Digite a nova senha" }]}
          >
            <Input.Password placeholder="Digite a nova senha" />
          </Form.Item>

          <Form.Item
            label="Confirmar nova senha"
            name="confirm_password"
            dependencies={["new_password"]}
            rules={[
              { required: true, message: "Confirme a nova senha" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("new_password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("As senhas não coincidem"));
                },
              }),
            ]}
          >
            <Input.Password placeholder="Confirme a nova senha" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
